module.exports = __webpack_public_path__ + "img/list_01_white.515c41ce.svg";